import { useState, useEffect } from "react";
import ListaProdottiBrandDBperCreaProdNC from "./ListaProdottiBrandDBperCreaProdNC";
import ColonnaRicercaAvanzata from "./ColonnaRicercaAvanzata";
import { useAuth0 } from "@auth0/auth0-react";
import stilePulsanti from "../../interfaccia/stilePulsanti";

function DBperCreaProd({
  setProductFunction,
  utente,
  brandSelezionato,
  listaProdottiBrand,
  setListaProdottiBrand,
  pubblicaTestiOImmagini,
  revisionaProdottiImportati,
  setRevisionaProdottiImportati,
}) {
  const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [ricerca, setRicerca] = useState(false);

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  const switchaRicerca = function () {
    setRicerca(!ricerca);
  };

  return (
    <div class="center">
      <div class="cf contentSubSubHeader sfondoBiancoTema">
        {utente.permessiAPI["update:database"] && ricerca && (
          <div class="fl-ns w-100 w-50-ns w-20-m w-10-l pr4 pl3 sfondoBiancoTema">
            <ColonnaRicercaAvanzata
              setListaProdottiBrand={setListaProdottiBrand}
              setProductFunction={setProductFunction}
              utente={utente}
              switchaRicerca={switchaRicerca}
            />
          </div>
        )}
        {!ricerca && utente.permessiAPI["update:database"] && (
          <div class="fl-ns w-100 w-50-ns w-20-m w-10-l pr4 pl3 sfondoBiancoTema">
            <div className="pa4 tc">
              {revisionaProdottiImportati ? (
                <div className="pa2">
                  <div
                    className={
                      stilePulsanti.tastoQuadratoArrBianco +
                      " scrittaColoreAltScuro"
                    }
                    onClick={() => setRevisionaProdottiImportati(false)}
                  >
                    {stilePulsanti.tastoImportAspetto}
                  </div>
                  <div className="pa2 ttu b">IMPORTATI</div>
                </div>
              ) : (
                <div className="pa2">
                  <div
                    className={stilePulsanti.tastoQuadratoArrBianco}
                    onClick={() => {
                      setRevisionaProdottiImportati(true);
                      setListaProdottiBrand([]);
                    }}
                  >
                    {stilePulsanti.tastoImportAspetto}
                  </div>
                  <div className="pa2 ttu">IMPORTATI</div>
                </div>
              )}
              <div className="pa2">
                <div
                  className={stilePulsanti.tastoQuadratoArrBianco}
                  onClick={switchaRicerca}
                >
                  {stilePulsanti.tastoCercaAvanzataAspettoScuro}
                </div>
                <div className="pa2 ttu">Cerca in DB</div>
              </div>
            </div>
          </div>
        )}
        <div class="fl-ns w-100 w-70-ns pr3 pl4 bl sfondoBiancoTema bordoColAlt">
          <h2>
            {!revisionaProdottiImportati && brandSelezionato}
            {!revisionaProdottiImportati &&
              pubblicaTestiOImmagini === 0 &&
              brandSelezionato !== "Ultimi articoli creati" && (
                <span> - prodotti senza immagini</span>
              )}
            {!revisionaProdottiImportati &&
              pubblicaTestiOImmagini === 1 &&
              brandSelezionato !== "Ultimi articoli creati" && (
                <span> - prodotti con immagini</span>
              )}
            {revisionaProdottiImportati && <span> Prodotti importati</span>}
          </h2>
          <ListaProdottiBrandDBperCreaProdNC
            brand={brandSelezionato}
            setProductFunction={setProductFunction}
            listaProdottiBrand={listaProdottiBrand}
            setListaProdottiBrand={setListaProdottiBrand}
            utente={utente}
            revisionaProdottiImportati={revisionaProdottiImportati}
          />
        </div>
      </div>
    </div>
  );
}

export default DBperCreaProd;
